/**
 * This script handles the loyalty program button clicks within the <loyalty-program> custom element.
 * When a button inside .yotpo-customer-logged-out-buttons is clicked, the script updates the URL with the hash #status,
 * triggering the hashchange event to handle the popup display.
 */
class LoyaltyProgram extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('click', this.globalClickHandler.bind(this), true);
  }

  globalClickHandler(event) {
    if (event.target.matches('.yotpo-customer-logged-out-buttons button')) {
      event.preventDefault();
      event.stopImmediatePropagation();

      window.location.hash = 'status';
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.globalClickHandler.bind(this), true);
  }
}

customElements.define('loyalty-program', LoyaltyProgram);